// extracted by mini-css-extract-plugin
export default {"admin":"admin_admin__aqsTP"};